export default {
  page: {
    myShop: 'My Shop',
    screenText: 'Settings',
    clearBtnText: 'Reset',
    submitText: 'Submit',
    exportText: 'Select to Download',
    exportLabel: 'Selected Download Format',
    conditionsLabel: 'Selected Conditions',
    categoryLabel: 'Selected Category',
    brandLabel: 'Selected Brand',
    noData: 'No Data',
    selectShopMsg: 'Please Select Shop(s)',
    selectFormatMsg: 'Please Select Report Format',
    selectCategoryMsg: 'Please select Category to Export',
    selectBrandMsg: 'Please select Brand(s)',
    benchmarkShopSearch: 'Select Comparison Shops',
    brand_tab: 'Brand',
    shop_tab: 'Shop',
    brand_tab1: 'Selected',
  },
  filter: {
    price: 'Select Prices',
    Prmotion: 'Select Promotions',
    monitored: 'Monitored Malls',
    selected: 'Selected',
    byMonth: 'By Month',
    byDay: 'By Day',
    selectPrice: 'Please Select Price',
  },
  showMsg: {
    title_0: 'Retail price',
    txt_0: 'The original price displayed on the website of the retailers.',
    title_1: 'Price after best discount',
    txt_1: 'The best price after highest discount displayed on the website and external discounts.',
    title_2: 'On sale price',
    txt_2: 'The discount price offered by the retailers.',
    title_3: 'Retailer Dis-Price',
    txt_3:
      'The price on top of discount based on ret-price or the estimated actual price on top of discount.',
    title_4: 'Cashback Price',
    txt_4: 'only applicable for Korean retailers.',
    title_5: 'Tax-free Price',
    txt_5: `Tick to show the prices after tax refund (only applicable to duty-paid retailers.) For North American retailers, select this price type to show the prices displayed on their website.
            For Japanese retailers, select  this price type to show the prices displayed on the website minus tax refund. `,
    title_6: 'Retailer Promotion',
    txt_6:
      'Display the information of the best discount promotion on the website and external promotions. If different tiers promotions reflect the same discount level, the promotion info is displayed randomly.',
    title_7: 'Best Retailer Discount',
    txt_7: 'To display the promotion info of the best discount on the website.',
    title_8: 'Cashback',
    txt_8: 'Cashback rate, only applicable to Korean retailers.',
    title_9: 'Currency Conversion',
    txt_9: 'To check the box, the prices will show in the same selected currency.',
    title_10: 'Status',
    txt_10: "To show SKU's historical status in the excel sheet.",
    title_11: 'Clearance Price',
    txt_11: 'Click to display the clearance prices in the excel sheet.',
    title_12: 'Ref Price',
    txt_12:
      'Because the retailer website does not display the original price of the product, hence we use the price from other retailers as references.',
  },
};
